const f = (s: number) => (s < 10 ? '0' + s : s);

export default (s: any) => {
  s = new Date(s).getTime();
  const d = new Date(parseInt(s, 10) || s);
  const year = d.getFullYear();
  const month = f(d.getMonth() + 1);
  const day = f(d.getDate());
  const hours = f(d.getHours());
  const minutes = f(d.getMinutes());
  return {
    date: `${year}-${month}-${day}`,
    time: `${hours}:${minutes}`,
    month: `${year}-${month}`,
    day: `${day}`,
  };
};
